/**
 * Custom-Mutations/-Queries mit `.returns(a.json())` (AppSync-Skalar
 * `AWSJSON`) liefern über den Amplify-Data-Client den Wert als JSON-**String**
 * zurück, nicht als bereits geparstes Objekt — anders, als man erwarten
 * würde. Beim Testen gefunden: `nutzerListe` (2 echte Nutzer laut Cognito)
 * erschien in der Oberfläche als hunderte leere Zeilen, weil der String wie
 * ein Array behandelt und über seine einzelnen Zeichen iteriert wurde.
 */
export function parseJson<T>(daten: unknown): T {
  return typeof daten === 'string' ? (JSON.parse(daten) as T) : (daten as T);
}
